"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9259],{

/***/ 74255:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _home_runner_work_calc_frontend_calc_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _home_runner_work_calc_frontend_calc_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(50029);
/* harmony import */ var _home_runner_work_calc_frontend_calc_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(4730);
/* harmony import */ var _home_runner_work_calc_frontend_calc_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87794);
/* harmony import */ var _home_runner_work_calc_frontend_calc_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_home_runner_work_calc_frontend_calc_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(67848);
/* harmony import */ var src_constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(18459);
/* harmony import */ var _cosmos_kit_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(54056);
/* harmony import */ var _helpers_chains__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(87038);
/* harmony import */ var rambda__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(6285);
/* harmony import */ var rambda__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(98991);
/* harmony import */ var src_pages_queryClient__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(98392);
/* harmony import */ var _hooks_useCalcClient_getClient_clients_cosmos__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(22606);
/* harmony import */ var _hooks_useDenoms__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(99867);



var _excluded = ["data"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_home_runner_work_calc_frontend_calc_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }











var useAllStrategies = function useAllStrategies() {
  var chains = (0,rambda__WEBPACK_IMPORTED_MODULE_8__/* .values */ .V)((0,_cosmos_kit_react__WEBPACK_IMPORTED_MODULE_3__/* .useChains */ .C$)(( true ? src_constants__WEBPACK_IMPORTED_MODULE_2__/* .MAINNET_CHAINS */ .ZY : 0).map(function (chainId) {
    return (0,_helpers_chains__WEBPACK_IMPORTED_MODULE_4__/* .getChainCosmosName */ .qs)(chainId);
  })));

  var _useDenoms = (0,_hooks_useDenoms__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(),
      denoms = _useDenoms.denoms,
      getDenomById = _useDenoms.getDenomById;

  var _useQuery = (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_9__/* .useQuery */ .a)(['all_strategies'], /*#__PURE__*/(0,_home_runner_work_calc_frontend_calc_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)( /*#__PURE__*/_home_runner_work_calc_frontend_calc_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().mark(function _callee2() {
    var fetchAllStrategies;
    return _home_runner_work_calc_frontend_calc_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            fetchAllStrategies = /*#__PURE__*/function () {
              var _ref2 = (0,_home_runner_work_calc_frontend_calc_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)( /*#__PURE__*/_home_runner_work_calc_frontend_calc_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().mark(function _callee(chain) {
                var client, calcClient, chainStrategies;
                return _home_runner_work_calc_frontend_calc_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        _context.next = 2;
                        return chain.getCosmWasmClient();

                      case 2:
                        client = _context.sent;
                        calcClient = (0,_hooks_useCalcClient_getClient_clients_cosmos__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(chain.chain.chain_id, (0,_helpers_chains__WEBPACK_IMPORTED_MODULE_4__/* .getDCAContractAddress */ .cr)(chain.chain.chain_id), client, getDenomById);
                        _context.next = 6;
                        return calcClient.fetchAllVaults();

                      case 6:
                        chainStrategies = _context.sent;
                        src_pages_queryClient__WEBPACK_IMPORTED_MODULE_5__/* .queryClient.setQueryData */ .E.setQueryData(['strategies', chain.chain.chain_id], chainStrategies);
                        return _context.abrupt("return", chainStrategies);

                      case 9:
                      case "end":
                        return _context.stop();
                    }
                  }
                }, _callee);
              }));

              return function fetchAllStrategies(_x) {
                return _ref2.apply(this, arguments);
              };
            }();

            _context2.t0 = rambda__WEBPACK_IMPORTED_MODULE_11__/* .map */ .UI;

            _context2.t1 = function (result) {
              return result.status === 'fulfilled' ? result.value : [];
            };

            _context2.next = 5;
            return Promise.allSettled(chains.map(fetchAllStrategies));

          case 5:
            _context2.t2 = _context2.sent;
            return _context2.abrupt("return", (0, _context2.t0)(_context2.t1, _context2.t2).flat());

          case 7:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  })), {
    enabled: !!chains && !!denoms,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    refetchOnReconnect: false,
    staleTime: 1000 * 60 * 10,
    meta: {
      errorMessage: 'Error fetching all strategies'
    }
  }),
      strategies = _useQuery.data,
      helpers = (0,_home_runner_work_calc_frontend_calc_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(_useQuery, _excluded);

  return _objectSpread({
    strategies: strategies
  }, helpers);
};

/* harmony default export */ __webpack_exports__["Z"] = (useAllStrategies);

/***/ }),

/***/ 49259:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "getTotalSwapped": function() { return /* binding */ getTotalSwapped; },
/* harmony export */   "totalFromCoins": function() { return /* binding */ totalFromCoins; },
/* harmony export */   "uniqueAddresses": function() { return /* binding */ uniqueAddresses; }
/* harmony export */ });
/* harmony import */ var _home_runner_work_calc_frontend_calc_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(27812);
/* harmony import */ var _home_runner_work_calc_frontend_calc_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var isomorphic_fetch__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94301);
/* harmony import */ var isomorphic_fetch__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(isomorphic_fetch__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(55281);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(22757);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(5674);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(71293);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(57747);
/* harmony import */ var _components_Layout__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19559);
/* harmony import */ var _components_SpendableBalances__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(95478);
/* harmony import */ var _utils_getDenomInfo__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11599);
/* harmony import */ var src_constants__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(18459);
/* harmony import */ var _hooks_useAllStrategies__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(74255);
/* harmony import */ var _helpers_getEndDateFromRemainingExecutions__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(22349);
/* harmony import */ var victory__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(81500);
/* harmony import */ var victory__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(11562);
/* harmony import */ var victory__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(73091);
/* harmony import */ var victory__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(60965);
/* harmony import */ var victory__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(58200);
/* harmony import */ var victory__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(43121);
/* harmony import */ var _models_StrategyType__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(94705);
/* harmony import */ var _helpers_format_formatFiat__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(50215);
/* harmony import */ var _helpers_strategy__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(6686);
/* harmony import */ var _helpers_strategy_isDcaPlus__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(67207);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(96486);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _hooks_useBalances__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(52560);
/* harmony import */ var _hooks_useChainId__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(12680);
/* harmony import */ var _helpers_chains__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(87038);
/* harmony import */ var _hooks_useFiatPrices__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(78719);
/* harmony import */ var _hooks_useDenoms__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(99867);
/* harmony import */ var rambda__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(6285);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(85893);



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_home_runner_work_calc_frontend_calc_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
























function orderCoinList(denoms, coinList, fiatPrices) {
  if (!coinList) {
    return [];
  }

  return coinList.map(function (coin) {
    var coingeckoId = denoms[coin.denom].coingeckoId;
    var denomConvertedAmount = (0,_utils_getDenomInfo__WEBPACK_IMPORTED_MODULE_4__/* .fromAtomic */ .b1)(denoms[coin.denom], Number(coin.amount));
    var fiatPriceInfo = fiatPrices[coingeckoId];
    var fiatAmount = fiatPriceInfo ? denomConvertedAmount * fiatPrices[coingeckoId].usd : 0;

    if ((0,lodash__WEBPACK_IMPORTED_MODULE_11__.isNaN)(fiatAmount)) {
      return _objectSpread(_objectSpread({}, coin), {}, {
        fiatAmount: 0
      });
    }

    return _objectSpread(_objectSpread({}, coin), {}, {
      fiatAmount: fiatAmount
    });
  }).sort(function (a, b) {
    return Number(b.fiatAmount) - Number(a.fiatAmount);
  });
}

function getTotalSwappedForDenom(denom, strategies) {
  return strategies.filter(function (strategy) {
    return strategy.rawData.swapped_amount.denom === denom.id;
  }).reduce(function (total, strategy) {
    return total + Number(strategy.rawData.swapped_amount.amount);
  }, 0).toFixed(6);
}

function getTotalSwapped(strategies, supportedDenoms) {
  var totalSwapped = supportedDenoms.map(function (denom) {
    return {
      denom: denom.id,
      amount: getTotalSwappedForDenom(denom, strategies)
    };
  });
  return totalSwapped;
}

function getTotalReceivedForDenom(denom, strategies) {
  return strategies.filter(function (strategy) {
    return strategy.rawData.received_amount.denom === denom.id;
  }).reduce(function (total, strategy) {
    return total + Number(strategy.rawData.received_amount.amount);
  }, 0).toFixed(6);
}

function getTotalReceived(strategies, supportedDenoms) {
  var totalSwapped = supportedDenoms.map(function (denom) {
    return {
      denom: denom.id,
      amount: getTotalReceivedForDenom(denom, strategies)
    };
  });
  return totalSwapped;
}

function getStrategiesByStatus(allStrategies, status) {
  var strategiesByStatus = allStrategies.filter(function (strategy) {
    return strategy.status === status;
  }) || [];
  var percentage = (Number(strategiesByStatus.length / allStrategies.length) * 100).toFixed(2);
  return {
    strategiesByStatus: strategiesByStatus,
    percentage: percentage
  };
}

function getStrategiesByTimeInterval(allStrategies, timeInterval) {
  var strategiesByTimeInterval = allStrategies.filter(function (strategy) {
    return strategy.rawData.time_interval === timeInterval;
  }) || [];
  var percentage = (Number(strategiesByTimeInterval.length / allStrategies.length) * 100).toFixed(2);
  return {
    strategiesByTimeInterval: strategiesByTimeInterval,
    percentage: percentage
  };
}

function getStrategiesByType(allStrategies, type) {
  var strategiesByType = allStrategies.filter(function (strategy) {
    return (0,_helpers_strategy__WEBPACK_IMPORTED_MODULE_9__/* .getStrategyType */ .dC)(strategy) === type;
  }) || [];
  var percentage = (Number(strategiesByType.length / allStrategies.length) * 100).toFixed(2);
  return {
    strategiesByType: strategiesByType,
    percentage: percentage
  };
}

function totalFromCoins(denoms, coins, fiatPrices) {
  return (coins === null || coins === void 0 ? void 0 : coins.filter(function (coin) {
    return coin.denom in denoms;
  }).map(function (balance) {
    var denomInfo = denoms[balance.denom];
    var denomConvertedAmount = (0,_utils_getDenomInfo__WEBPACK_IMPORTED_MODULE_4__/* .fromAtomic */ .b1)(denomInfo, Number(balance.amount));
    var fiatPriceInfo = fiatPrices[denomInfo.coingeckoId];
    var fiatAmount = fiatPriceInfo ? denomConvertedAmount * fiatPrices[denomInfo.coingeckoId].usd : 0;

    if ((0,lodash__WEBPACK_IMPORTED_MODULE_11__.isNaN)(fiatAmount)) {
      return 0;
    }

    return fiatAmount;
  }).reduce(function (amount, total) {
    return total + amount;
  }, 0)) || 0;
}

function daysUntil(date) {
  var now = new Date();
  var diff = date.getTime() - now.getTime();
  return Math.ceil(diff / (1000 * 3600 * 24));
}

function weeksUntil(date) {
  var now = new Date();
  var diff = date.getTime() - now.getTime();
  return Math.ceil(diff / (1000 * 3600 * 24 * 7));
}

function monthsUntil(date) {
  var now = new Date();
  var diff = date.getTime() - now.getTime();
  return Math.ceil(diff / (1000 * 3600 * 24 * 30));
}

function hoursUntil(date) {
  var now = new Date();
  var diff = date.getTime() - now.getTime();
  return Math.ceil(diff / (1000 * 3600));
} // map functions to time intervals


var timeIntervalMap = {
  every_second: function every_second() {
    return 1;
  },
  every_minute: function every_minute() {
    return 1;
  },
  half_hourly: function half_hourly() {
    return 30;
  },
  hourly: hoursUntil,
  half_daily: function half_daily() {
    return 12;
  },
  daily: daysUntil,
  weekly: weeksUntil,
  fortnightly: function fortnightly() {
    return 2;
  },
  monthly: monthsUntil
};

function getSwapCountForStrategyUntilDate(strategy, date) {
  if (typeof strategy.rawData.time_interval === 'string') {
    return Math.min(timeIntervalMap[strategy.rawData.time_interval](date), (0,_helpers_strategy__WEBPACK_IMPORTED_MODULE_9__/* .getStrategyRemainingExecutions */ .wW)(strategy));
  }

  return Math.min(strategy.rawData.time_interval.custom.seconds, (0,_helpers_strategy__WEBPACK_IMPORTED_MODULE_9__/* .getStrategyRemainingExecutions */ .wW)(strategy));
}

function getFeesPerSwapForStrategy(strategy) {
  var fees = src_constants__WEBPACK_IMPORTED_MODULE_5__/* .SWAP_FEE */ .OJ * Number(strategy.rawData.swap_amount);
  var convertedFees = (0,_utils_getDenomInfo__WEBPACK_IMPORTED_MODULE_4__/* .fromAtomic */ .b1)(strategy.initialDenom, fees);
  return convertedFees;
}

function getFeesUntilDate(strategy, date) {
  var swapCount = getSwapCountForStrategyUntilDate(strategy, date);
  return getFeesPerSwapForStrategy(strategy) * swapCount;
}

function getFiatPriceFromList(fiatPrices, denom) {
  var _fiatPrices$denom$coi;

  return (_fiatPrices$denom$coi = fiatPrices[denom.coingeckoId]) === null || _fiatPrices$denom$coi === void 0 ? void 0 : _fiatPrices$denom$coi.usd;
}

function getProjectedRevenueForStrategyForDate(strategy, date, fiatPrices) {
  var fees = getFeesUntilDate(strategy, date);
  var fiatPrice = getFiatPriceFromList(fiatPrices, strategy.initialDenom);
  return fees * fiatPrice;
}

function getProjectedRevenueForStrategiesForDate(strategies, date, fiatPrices) {
  return strategies.map(function (strategy) {
    return getProjectedRevenueForStrategyForDate(strategy, date, fiatPrices);
  }).reduce(function (amount, total) {
    return total + amount;
  }, 0);
}

function timeUntilEndOfStrategyInMilliseconds(strategy) {
  var now = new Date();
  var now2 = new Date();
  var end = (0,_helpers_getEndDateFromRemainingExecutions__WEBPACK_IMPORTED_MODULE_18__/* .getEndDateFromRemainingExecutions */ .G)(strategy, now2, (0,_helpers_strategy__WEBPACK_IMPORTED_MODULE_9__/* .getStrategyRemainingExecutions */ .wW)(strategy));
  if (!end) return 0;
  var diff = end.getTime() - now.getTime();
  return diff;
}

function getMaxDurationInMilliseconds(strategies) {
  return Math.max.apply(Math, (0,_home_runner_work_calc_frontend_calc_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)(strategies.map(function (strategy) {
    return timeUntilEndOfStrategyInMilliseconds(strategy);
  })));
}

function getAverageDurationForActiveStrategies(strategies) {
  var totalDuration = strategies.filter(_helpers_strategy__WEBPACK_IMPORTED_MODULE_9__/* .isStrategyActive */ .KT).map(function (strategy) {
    return timeUntilEndOfStrategyInMilliseconds(strategy);
  }).reduce(function (amount, total) {
    return total + amount;
  }, 0);
  return totalDuration / strategies.length;
}

function groupStrategiesByOwnerThenStatus(strategies) {
  var strategiesGroupedByOwnerThenStatus = {};
  strategies.forEach(function (strategy) {
    var owner = strategy.owner,
        status = strategy.status;

    if (!strategiesGroupedByOwnerThenStatus[owner]) {
      strategiesGroupedByOwnerThenStatus[owner] = {};
    }

    if (!strategiesGroupedByOwnerThenStatus[owner][status]) {
      strategiesGroupedByOwnerThenStatus[owner][status] = [];
    }

    strategiesGroupedByOwnerThenStatus[owner][status].push(strategy);
  });
  return strategiesGroupedByOwnerThenStatus;
}

function getWalletsWithOnlyScheduledStrategies(strategies) {
  var strategiesByOwnerGroupedByStatus = groupStrategiesByOwnerThenStatus(strategies);
  return Object.keys(strategiesByOwnerGroupedByStatus).filter(function (owner) {
    var statuses = Object.keys(strategiesByOwnerGroupedByStatus[owner]);
    return statuses.length === 1 && statuses[0] === 'scheduled';
  });
}

function getWalletsWithOnlyCancelledStrategies(strategies) {
  var strategiesByOwnerGroupedByStatus = groupStrategiesByOwnerThenStatus(strategies);
  return Object.keys(strategiesByOwnerGroupedByStatus).filter(function (owner) {
    var statuses = Object.keys(strategiesByOwnerGroupedByStatus[owner]);
    return statuses.length === 1 && statuses[0] === 'cancelled';
  });
}

function getWalletsWithActiveStrategies(strategies) {
  var strategiesByOwnerGroupedByStatus = groupStrategiesByOwnerThenStatus(strategies);
  return Object.keys(strategiesByOwnerGroupedByStatus).filter(function (owner) {
    var statuses = Object.keys(strategiesByOwnerGroupedByStatus[owner]);
    return statuses.includes('active');
  });
}

function getWalletsWithOnlyInactive(strategies) {
  var strategiesByOwnerGroupedByStatus = groupStrategiesByOwnerThenStatus(strategies);
  return Object.keys(strategiesByOwnerGroupedByStatus).filter(function (owner) {
    var statuses = Object.keys(strategiesByOwnerGroupedByStatus[owner]);
    return statuses.length === 1 && statuses[0] === 'inactive';
  });
}

function getWalletsWithOnlyInactiveAndCancelled(strategies) {
  var strategiesByOwnerGroupedByStatus = groupStrategiesByOwnerThenStatus(strategies);
  return Object.keys(strategiesByOwnerGroupedByStatus).filter(function (owner) {
    var statuses = Object.keys(strategiesByOwnerGroupedByStatus[owner]);
    return statuses.length === 2 && statuses.includes('inactive') && statuses.includes('cancelled');
  });
}

function uniqueAddresses(allStrategies) {
  return Array.from(new Set((allStrategies === null || allStrategies === void 0 ? void 0 : allStrategies.map(function (strategy) {
    return strategy.owner;
  })) || []));
}

function Page() {
  var _useDenoms = (0,_hooks_useDenoms__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(),
      denoms = _useDenoms.denoms;

  var _useChainId = (0,_hooks_useChainId__WEBPACK_IMPORTED_MODULE_13__/* .useChainId */ .x)(),
      chainId = _useChainId.chainId;

  var _useBalances = (0,_hooks_useBalances__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)((0,_helpers_chains__WEBPACK_IMPORTED_MODULE_14__/* .getDCAContractAddress */ .cr)(chainId)),
      contractBalances = _useBalances.balances;

  var _useBalances2 = (0,_hooks_useBalances__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)((0,_helpers_chains__WEBPACK_IMPORTED_MODULE_14__/* .getFeeTakerAddress */ .W$)(chainId)),
      feeTakerBalances = _useBalances2.balances;

  var _useFiatPrices = (0,_hooks_useFiatPrices__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)(),
      fiatPrices = _useFiatPrices.fiatPrices;

  var _useAllStrategies = (0,_hooks_useAllStrategies__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(),
      strategies = _useAllStrategies.strategies;

  var uniqueWalletAddresses = uniqueAddresses(strategies);
  if (!fiatPrices || !strategies || !denoms) return null;
  var totalInContract = totalFromCoins(denoms[chainId], contractBalances, fiatPrices);
  var totalInFeeTaker = totalFromCoins(denoms[chainId], feeTakerBalances, fiatPrices);
  var chainDenoms = (0,rambda__WEBPACK_IMPORTED_MODULE_20__/* .values */ .V)(denoms[chainId]);
  var totalSwappedAmounts = getTotalSwapped(strategies, chainDenoms);
  var totalSwappedTotal = totalFromCoins(denoms[chainId], totalSwappedAmounts, fiatPrices);
  var totalReceivedAmounts = getTotalReceived(strategies, chainDenoms);
  var totalReceivedTotal = totalFromCoins(denoms[chainId], totalReceivedAmounts, fiatPrices);
  var thirtyDaysFromNow = new Date();
  thirtyDaysFromNow.setDate(thirtyDaysFromNow.getDate() + 30);
  var threeMonthsFromNow = new Date();
  threeMonthsFromNow.setDate(threeMonthsFromNow.getDate() + 90);
  var aYearFromNow = new Date();
  aYearFromNow.setDate(aYearFromNow.getDate() + 365);
  var thirtyDayRevenue = getProjectedRevenueForStrategiesForDate(strategies, thirtyDaysFromNow, fiatPrices);
  var threeMonthRevenue = getProjectedRevenueForStrategiesForDate(strategies, threeMonthsFromNow, fiatPrices);
  var twelveMonthRevenue = getProjectedRevenueForStrategiesForDate(strategies, aYearFromNow, fiatPrices);
  var averageDuration = getAverageDurationForActiveStrategies(strategies);
  var averageDurationInDays = Math.floor(averageDuration / (1000 * 60 * 60 * 24));
  var maxDurationInDays = getMaxDurationInMilliseconds(strategies) / (1000 * 60 * 60 * 24);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_21__/* .Stack */ .K, {
    spacing: 6,
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_22__/* .Heading */ .X, {
      "data-testid": "details-heading",
      children: "CALC statistics"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_23__/* .SimpleGrid */ .M, {
      spacing: 12,
      columns: [1, null, 2, null, 3],
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_21__/* .Stack */ .K, {
        spacing: 2,
        layerStyle: "panel",
        p: 4,
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_22__/* .Heading */ .X, {
          size: "md",
          children: "Totals"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_22__/* .Heading */ .X, {
          size: "sm"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_24__/* .Text */ .x, {
          children: ["Unique wallets with strategies: ", uniqueWalletAddresses.length]
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_24__/* .Text */ .x, {
          children: ["Total strategies: ", strategies === null || strategies === void 0 ? void 0 : strategies.length]
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_24__/* .Text */ .x, {
          textStyle: "body-xs",
          children: ["Strategies per wallet: ", (((strategies === null || strategies === void 0 ? void 0 : strategies.length) || 0) / uniqueWalletAddresses.length).toFixed(2)]
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_24__/* .Text */ .x, {
          textStyle: "body-xs",
          children: ["Strategies with autostaking: ", strategies === null || strategies === void 0 ? void 0 : strategies.filter(_helpers_strategy__WEBPACK_IMPORTED_MODULE_9__/* .isStrategyAutoStaking */ .WD).length]
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_24__/* .Text */ .x, {
          textStyle: "body-xs",
          children: ["Strategies using DCA+: ", strategies === null || strategies === void 0 ? void 0 : strategies.filter(_helpers_strategy_isDcaPlus__WEBPACK_IMPORTED_MODULE_10__/* .isDcaPlus */ .o).length]
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_24__/* .Text */ .x, {
          textStyle: "body-xs",
          children: ["Average Time Until End of Strategy: ", averageDurationInDays, " days (Max: ", maxDurationInDays, " days)"]
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_24__/* .Text */ .x, {
          textStyle: "body-xs",
          children: ["Unique wallets with only scheduled strategies: ", getWalletsWithOnlyScheduledStrategies(strategies).length]
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_24__/* .Text */ .x, {
          textStyle: "body-xs",
          children: ["Unique wallets with active an active strategy: ", getWalletsWithActiveStrategies(strategies).length]
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_24__/* .Text */ .x, {
          textStyle: "body-xs",
          children: ["Unique wallets with only completed strategies: ", getWalletsWithOnlyInactive(strategies).length]
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_24__/* .Text */ .x, {
          textStyle: "body-xs",
          children: ["Unique wallets with only completed and cancelled strategies:", ' ', getWalletsWithOnlyInactiveAndCancelled(strategies).length]
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_24__/* .Text */ .x, {
          textStyle: "body-xs",
          children: ["Unique wallets with only cancelled strategies: ", getWalletsWithOnlyCancelledStrategies(strategies).length]
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_21__/* .Stack */ .K, {
        spacing: 4,
        layerStyle: "panel",
        p: 4,
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_22__/* .Heading */ .X, {
          size: "md",
          children: "Amount in contract"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_24__/* .Text */ .x, {
          children: ["Total: ", (0,_helpers_format_formatFiat__WEBPACK_IMPORTED_MODULE_8__/* .formatFiat */ .M)(totalInContract)]
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_25__/* .Box */ .xu, {
          w: 300,
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsx)(_components_SpendableBalances__WEBPACK_IMPORTED_MODULE_3__/* .BalanceList */ .U, {
            balances: orderCoinList(denoms[chainId], contractBalances !== null && contractBalances !== void 0 ? contractBalances : [], fiatPrices)
          })
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_21__/* .Stack */ .K, {
        spacing: 4,
        layerStyle: "panel",
        p: 4,
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_22__/* .Heading */ .X, {
          size: "md",
          children: "Amount in Fee Taker"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_24__/* .Text */ .x, {
          children: ["Total: ", (0,_helpers_format_formatFiat__WEBPACK_IMPORTED_MODULE_8__/* .formatFiat */ .M)(totalInFeeTaker)]
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_25__/* .Box */ .xu, {
          w: 300,
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsx)(_components_SpendableBalances__WEBPACK_IMPORTED_MODULE_3__/* .BalanceList */ .U, {
            balances: orderCoinList(denoms[chainId], feeTakerBalances !== null && feeTakerBalances !== void 0 ? feeTakerBalances : [], fiatPrices)
          })
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_21__/* .Stack */ .K, {
        spacing: 4,
        layerStyle: "panel",
        p: 4,
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_22__/* .Heading */ .X, {
          size: "md",
          children: "Projected revenue (30 Days)"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_24__/* .Text */ .x, {
          textStyle: "body-xs",
          children: "Based on expected executions and swap amounts "
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_23__/* .SimpleGrid */ .M, {
          columns: 2,
          spacing: 4,
          textStyle: "bod",
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_24__/* .Text */ .x, {
            children: " 30 Days: "
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_24__/* .Text */ .x, {
            children: (0,_helpers_format_formatFiat__WEBPACK_IMPORTED_MODULE_8__/* .formatFiat */ .M)(thirtyDayRevenue)
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_24__/* .Text */ .x, {
            children: " 3 Months: "
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_24__/* .Text */ .x, {
            children: (0,_helpers_format_formatFiat__WEBPACK_IMPORTED_MODULE_8__/* .formatFiat */ .M)(threeMonthRevenue)
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_24__/* .Text */ .x, {
            children: " 1 Year: "
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_24__/* .Text */ .x, {
            children: (0,_helpers_format_formatFiat__WEBPACK_IMPORTED_MODULE_8__/* .formatFiat */ .M)(twelveMonthRevenue)
          })]
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_21__/* .Stack */ .K, {
        spacing: 4,
        layerStyle: "panel",
        p: 4,
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_22__/* .Heading */ .X, {
          size: "md",
          children: "Amount Swapped"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_24__/* .Text */ .x, {
          children: ["Total: ", (0,_helpers_format_formatFiat__WEBPACK_IMPORTED_MODULE_8__/* .formatFiat */ .M)(totalSwappedTotal)]
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_25__/* .Box */ .xu, {
          w: 300,
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsx)(_components_SpendableBalances__WEBPACK_IMPORTED_MODULE_3__/* .BalanceList */ .U, {
            balances: orderCoinList(denoms[chainId], totalSwappedAmounts, fiatPrices)
          })
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_21__/* .Stack */ .K, {
        spacing: 4,
        layerStyle: "panel",
        p: 4,
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_22__/* .Heading */ .X, {
          size: "md",
          children: "Amount Received"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_24__/* .Text */ .x, {
          children: ["Total: ", (0,_helpers_format_formatFiat__WEBPACK_IMPORTED_MODULE_8__/* .formatFiat */ .M)(totalReceivedTotal)]
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_25__/* .Box */ .xu, {
          w: 300,
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsx)(_components_SpendableBalances__WEBPACK_IMPORTED_MODULE_3__/* .BalanceList */ .U, {
            balances: orderCoinList(denoms[chainId], totalReceivedAmounts, fiatPrices)
          })
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_21__/* .Stack */ .K, {
        spacing: 4,
        layerStyle: "panel",
        p: 4,
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_22__/* .Heading */ .X, {
          size: "md",
          children: "Strategies By Status"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsxs)(victory__WEBPACK_IMPORTED_MODULE_26__/* .VictoryChart */ .k, {
          theme: victory__WEBPACK_IMPORTED_MODULE_27__/* .VictoryTheme.material */ .J.material,
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsx)(victory__WEBPACK_IMPORTED_MODULE_28__/* .VictoryAxis */ .E, {
            dependentAxis: true,
            tickFormat: function tickFormat(tick) {
              return "".concat(tick);
            },
            style: {
              grid: {
                stroke: '#F4F5F7',
                strokeWidth: 0.5
              }
            }
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsx)(victory__WEBPACK_IMPORTED_MODULE_28__/* .VictoryAxis */ .E, {
            tickFormat: function tickFormat(tick) {
              return "".concat(tick);
            },
            style: {
              grid: {
                stroke: '#F4F5F7',
                strokeWidth: 0.5
              }
            }
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsx)(victory__WEBPACK_IMPORTED_MODULE_29__/* .VictoryBar */ .u, {
            data: ['scheduled', 'active', 'inactive', 'cancelled'].map(function (timeInterval) {
              var _ref = getStrategiesByStatus(strategies || [], timeInterval) || [],
                  strategiesByStatus = _ref.strategiesByStatus;

              return {
                x: timeInterval,
                y: strategiesByStatus.length,
                label: "".concat(timeInterval, " \n(").concat(strategiesByStatus.length, ")")
              };
            }),
            colorScale: ['tomato', 'orange', 'gold', 'cyan'],
            style: {
              labels: {
                fill: 'white'
              }
            }
          })]
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_21__/* .Stack */ .K, {
        spacing: 4,
        layerStyle: "panel",
        p: 4,
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_22__/* .Heading */ .X, {
          size: "md",
          children: "Strategies By Status Unique"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsxs)(victory__WEBPACK_IMPORTED_MODULE_26__/* .VictoryChart */ .k, {
          theme: victory__WEBPACK_IMPORTED_MODULE_27__/* .VictoryTheme.material */ .J.material,
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsx)(victory__WEBPACK_IMPORTED_MODULE_28__/* .VictoryAxis */ .E, {
            dependentAxis: true,
            tickFormat: function tickFormat(tick) {
              return "".concat(tick);
            },
            style: {
              grid: {
                stroke: '#F4F5F7',
                strokeWidth: 0.5
              }
            }
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsx)(victory__WEBPACK_IMPORTED_MODULE_28__/* .VictoryAxis */ .E, {
            tickFormat: function tickFormat(tick) {
              return "".concat(tick);
            },
            style: {
              grid: {
                stroke: '#F4F5F7',
                strokeWidth: 0.5
              }
            }
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsx)(victory__WEBPACK_IMPORTED_MODULE_29__/* .VictoryBar */ .u, {
            data: ['scheduled', 'active', 'inactive', 'cancelled'].map(function (status) {
              var strategiesByStatus = Array.from(new Set((getStrategiesByStatus(strategies || [], status) || []).strategiesByStatus.map(function (strategy) {
                return strategy.owner;
              })));
              return {
                x: status,
                y: strategiesByStatus.length,
                label: "".concat(status, " \n(").concat(strategiesByStatus.length, ")")
              };
            }),
            colorScale: ['tomato', 'orange', 'gold', 'cyan'],
            style: {
              labels: {
                fill: 'white'
              }
            }
          })]
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_21__/* .Stack */ .K, {
        spacing: 4,
        layerStyle: "panel",
        p: 4,
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_22__/* .Heading */ .X, {
          size: "md",
          children: "Strategies By Time Interval"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsxs)(victory__WEBPACK_IMPORTED_MODULE_26__/* .VictoryChart */ .k, {
          theme: victory__WEBPACK_IMPORTED_MODULE_27__/* .VictoryTheme.material */ .J.material,
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsx)(victory__WEBPACK_IMPORTED_MODULE_28__/* .VictoryAxis */ .E, {
            dependentAxis: true,
            tickFormat: function tickFormat(tick) {
              return "".concat(tick);
            },
            style: {
              grid: {
                stroke: '#F4F5F7',
                strokeWidth: 0.5
              }
            }
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsx)(victory__WEBPACK_IMPORTED_MODULE_28__/* .VictoryAxis */ .E, {
            tickFormat: function tickFormat(tick) {
              return "".concat(tick);
            },
            style: {
              grid: {
                stroke: '#F4F5F7',
                strokeWidth: 0.5
              }
            }
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsx)(victory__WEBPACK_IMPORTED_MODULE_29__/* .VictoryBar */ .u, {
            animate: {
              duration: 2000,
              onLoad: {
                duration: 1000
              }
            },
            data: ['hourly', 'daily', 'weekly', 'monthly'].map(function (timeInterval) {
              var _ref2 = getStrategiesByTimeInterval(strategies || [], timeInterval) || [],
                  strategiesByTimeInterval = _ref2.strategiesByTimeInterval,
                  percentage = _ref2.percentage;

              return {
                x: timeInterval,
                y: strategiesByTimeInterval.length,
                label: "".concat(percentage, "%")
              };
            }),
            colorScale: ['tomato', 'orange', 'gold', 'cyan'],
            style: {
              labels: {
                fill: 'white'
              }
            }
          })]
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_21__/* .Stack */ .K, {
        spacing: 4,
        layerStyle: "panel",
        p: 4,
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_22__/* .Heading */ .X, {
          size: "md",
          children: "Strategies By Type"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsxs)(victory__WEBPACK_IMPORTED_MODULE_26__/* .VictoryChart */ .k, {
          theme: victory__WEBPACK_IMPORTED_MODULE_27__/* .VictoryTheme.material */ .J.material,
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsx)(victory__WEBPACK_IMPORTED_MODULE_28__/* .VictoryAxis */ .E, {
            dependentAxis: true,
            tickFormat: function tickFormat(tick) {
              return "".concat(tick);
            },
            style: {
              grid: {
                stroke: '#F4F5F7',
                strokeWidth: 0.5
              }
            }
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsx)(victory__WEBPACK_IMPORTED_MODULE_28__/* .VictoryAxis */ .E, {
            tickFormat: function tickFormat(tick) {
              return "".concat(tick);
            },
            style: {
              grid: {
                stroke: '#F4F5F7',
                strokeWidth: 0.5
              }
            }
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsx)(victory__WEBPACK_IMPORTED_MODULE_29__/* .VictoryBar */ .u, {
            animate: {
              duration: 2000,
              onLoad: {
                duration: 1000
              }
            },
            data: [_models_StrategyType__WEBPACK_IMPORTED_MODULE_7__/* .StrategyType.DCAIn */ .h.DCAIn, _models_StrategyType__WEBPACK_IMPORTED_MODULE_7__/* .StrategyType.DCAOut */ .h.DCAOut, _models_StrategyType__WEBPACK_IMPORTED_MODULE_7__/* .StrategyType.DCAPlusIn */ .h.DCAPlusIn, _models_StrategyType__WEBPACK_IMPORTED_MODULE_7__/* .StrategyType.DCAPlusOut */ .h.DCAPlusOut].map(function (type) {
              var _ref3 = getStrategiesByType(strategies || [], type) || [],
                  strategiesByType = _ref3.strategiesByType,
                  percentage = _ref3.percentage;

              return {
                x: type,
                y: strategiesByType.length,
                label: "".concat(percentage, "%")
              };
            }),
            colorScale: ['tomato', 'orange', 'gold', 'cyan'],
            style: {
              labels: {
                fill: 'white'
              }
            }
          })]
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_21__/* .Stack */ .K, {
        spacing: 4,
        layerStyle: "panel",
        p: 4,
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_22__/* .Heading */ .X, {
          size: "md",
          children: "Active Strategies By Remaining Days"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsxs)(victory__WEBPACK_IMPORTED_MODULE_26__/* .VictoryChart */ .k, {
          theme: victory__WEBPACK_IMPORTED_MODULE_27__/* .VictoryTheme.material */ .J.material,
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsx)(victory__WEBPACK_IMPORTED_MODULE_28__/* .VictoryAxis */ .E, {
            dependentAxis: true,
            tickFormat: function tickFormat(tick) {
              return "".concat(tick);
            },
            style: {
              grid: {
                stroke: '#F4F5F7',
                strokeWidth: 0.5
              }
            }
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsx)(victory__WEBPACK_IMPORTED_MODULE_28__/* .VictoryAxis */ .E, {
            tickFormat: function tickFormat(tick) {
              return "".concat(tick);
            },
            style: {
              grid: {
                stroke: '#F4F5F7',
                strokeWidth: 0.5
              }
            }
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsx)(victory__WEBPACK_IMPORTED_MODULE_30__/* ["default"] */ .Z, {
            animate: {
              duration: 2000,
              onLoad: {
                duration: 1000
              }
            },
            bins: 20,
            data: strategies.filter(_helpers_strategy__WEBPACK_IMPORTED_MODULE_9__/* .isStrategyActive */ .KT).map(function (strategy) {
              var remainingTime = timeUntilEndOfStrategyInMilliseconds(strategy);
              var remainingTimeInDays = Math.round(remainingTime / (1000 * 60 * 60 * 24));
              return {
                x: remainingTimeInDays,
                label: remainingTimeInDays
              };
            }),
            labelComponent: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsx)(victory__WEBPACK_IMPORTED_MODULE_31__/* ["default"] */ .Z, {}),
            colorScale: ['tomato', 'orange', 'gold', 'cyan'],
            style: {
              labels: {
                fill: 'white'
              }
            }
          })]
        })]
      })]
    })]
  });
}

Page.getLayout = _components_Layout__WEBPACK_IMPORTED_MODULE_2__/* .getSidebarLayout */ .M;
/* harmony default export */ __webpack_exports__["default"] = (Page);

/***/ })

}]);